import React, { useEffect, useContext } from "react";
import { connect } from "react-redux";
import Draggable from "./Draggable/Draggable";
import * as actionTypes from "../store/Actions/actions";
import * as UTILS from "../utils/Utils";
// Elements
import BUTTON from "../components/Elements/Button/Button";
import Image from "../components/Elements/Image/Image";
import File from "../components/Elements/File/File";
import TimerElement from "../components/Elements/Timer/Timer";
import Text from "../components/Elements/Text/Text";
import Form from "../components/Elements/Form/Form";
import Line from "../components/Elements/Line/Line";
import VideoElement from "../components/Elements/Video/Video";
import TABLEEditor from "../components/Elements/TABLE/Table";
import HTMLEditor from "../components/Elements/HTML/Html";
import RowColumns from "../components/Elements/Column/Columns";
import Accordion from "../components/Elements/Accordion/Accordion";
import { DragAndDropContext } from "../context/DragAndDropContext";

import ErrorBoundary from "../utils/ErrorBoundary";
import AddToolButton from "../components/Tool/AddToolButton/AddToolButton";

const ElementsRender = (props) => {
  const {
    onDrop,
    onDrag,
    onDragOver,
    onDragEnter,
    dragOverElement,
    onDragEnd,
    dragOverElementIndex,
    addIndex,
    barLocation,
  } = useContext(DragAndDropContext);
  useEffect(() => {

  }, [
    props.layout,
    props.tool,
    props.resizeID,
    props.mobileView,
    props.preset,
    props.showAddElement,
    props.enableWidthForRow,
    props.layoutList,
    props.containerWidth,
  ]);

  const layoutElements = props.layout.map((item, index) => {
    if (item && item.data == "Accordion") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            classlist={
              "item accordionMain " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}

          >
            <Accordion
              key={`${item.data}-${index}`}
              accordionNestType="accordionColumn"
              preset={props.preset}
              selectedFont={props.selectedFont}
              showAddElement={props.showAddElement}
              preventDrop={props.preventDrop}
              pagesList={props.pagesList}
              ID={item.id}
              onAddElementorColumn={props.onAddElementorColumn}
              onAddElementorColumnInColumn={props.onAddElementorColumnInColumn}
              deleteElement={
                props.deleteElement
              }
              cloneElement={
                props.cloneElement
              }
              payload={props.payload}
              payloadActive={props.payloadActive}
              changeColmLayout={props.changeColmLayout}
              mobileView={props.mobileView}
              resizeID={props.resizeID}
              resizeColumn={() => {
                props.resizeColumn(item.id);
              }}
              label={item.label}
              deskWidth={item.deskWidth}
              index={index}
              addedIndex={props.addedIndex}
              initP={props.initP}
              userID={props.userID}
              sessionID={props.sessionID}
              rowStyle={item.rowStyle ? item.rowStyle : null}
              rowBg={
                item.rowStyle && item.rowStyle.rowBg
                  ? item.rowStyle.rowBg
                  : undefined
              }
              rowOpacity={
                item.rowStyle && item.rowStyle.opacity
                  ? item.rowStyle.opacity
                  : "1.0"
              }
              rowBgColor={
                item.rowStyle && item.rowStyle.rowBgColor
                  ? item.rowStyle.rowBgColor
                  : "transparent"
              }
              rowBorderColor={
                item.rowStyle && item.rowStyle.rowBorderColor
                  ? item.rowStyle.rowBorderColor
                  : "#000000"
              }
              gutterSpaceBtwnCol={
                item.rowStyle && item.rowStyle.gutterSpaceBtwnCol
                  ? item.rowStyle.gutterSpaceBtwnCol
                  : "0"
              }
              gutterSpaceBtwnColMobile={
                item.rowStyle && item.rowStyle.gutterSpaceBtwnColMobile
                  ? item.rowStyle.gutterSpaceBtwnColMobile
                  : "0"
              }
              bgRepeat={
                item.rowStyle && item.rowStyle.bgRepeat
                  ? item.rowStyle.bgRepeat
                  : "no-repeat"
              }
              bgSize={
                item.rowStyle && item.rowStyle.bgSize
                  ? item.rowStyle.bgSize
                  : "cover"
              }
              borderWidth={
                item.rowStyle && item.rowStyle.borderWidth
                  ? item.rowStyle.borderWidth
                  : "0"
              }
              rowCroppedBg={
                item.rowStyle && item.rowStyle.croppedBg !== null
                  ? item.rowStyle.croppedBg
                  : undefined
              }
              rowBgWidth={
                item.rowStyle && item.rowStyle.bgWidth
                  ? item.rowStyle.bgWidth
                  : undefined
              }
              element={item}
              columns={item.columns}
              addRemoveColumn={props.addRemoveColumn}
              removeColumn={props.removeColumn}
              itemID={props.itemID}
              imageClicked={props.imageClicked}
              addImage={props.addImage}
              changeImage={props.changeImage}
              clickedImage={props.clickedImage}
              clickedImageID={props.clickedImageID}
              layout={props.layoutState}
              toggleUploadPopup={props.toggleUploadPopup}
              dragLeave={props.dragLeave}
              onChangeHandler={props.onChangeHandler}
              modalUpload={props.modalUpload}
              selectedFile={props.selectedFile}
              videoClicked={props.videoClicked}
              videoDataID={props.videoDataID}
              addVideo={props.addVideo}
              videoOption={props.videoOption}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "BUTTON") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <BUTTON
              pagesList={props.pagesList}
              Link={item.link}
              LinkName={item.linkname}
              mobileView={props.mobileView}
              LinkType={item.linktype}
              element={item}
              LinkOpen={item.linkopen}
              UseSocial={item.use_social}
              deleteElement={props.deleteElement}
              ID={item.id}
              style={item.style}
              mobileAlignment={item.mobileAlignment || "none"}
              fullWidth={item.style.width || "auto"}
              width={item.style.width ? item.style.width : "auto"}
              height={item.style.height ? item.style.height : "auto"}
              btnWidthUnit={
                item.style.btnWidthUnit ? item.style.btnWidthUnit : "px"
              }
              btnHeightUnit={
                item.style.btnHeightUnit ? item.style.btnHeightUnit : "px"
              }
              fontName={item.style.fontFamily}
              fontSize={item.style.fontSize}
              key={`${item.data}-${index}`}
              label={item.label}
              borderRadius={item.style.borderRadius}
              fontWeight={item.style.fontWeight || "normal"}
              borderWidthVal={item.style.borderWidth}
              borderWidth={item.style.borderWidth}
              paddingTop={item.style.paddingTop}
              paddingRight={item.style.paddingRight}
              paddingBottom={item.style.paddingBottom}
              paddingLeft={item.style.paddingLeft}
              btnPaddingUnit={item.style.btnPaddingUnit}
              btnMarginUnit={item.style.btnMarginUnit}
              marginTop={item.style.marginTop || 0}
              marginRight={item.style.marginRight || 0}
              marginBottom={item.style.marginBottom || 0}
              marginLeft={item.style.marginLeft || 0}
              buttonURL={item.buttonURL}
              content={item.content}
              keyID={item.id}
              editVal={item.edit}
              editStatus={item.edit}
              normalTextColor={
                item.normalBtn.txtColor.rgb || {
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                }
              }
              normalBtnBg={
                item.normalBtn.btnBG.rgb || { r: 12, g: 50, b: 84, a: 1 }
              }
              normalBtnBorder={
                item.normalBtn.btnBorder.rgb || {
                  r: 12,
                  g: 50,
                  b: 84,
                  a: 1,
                }
              }
              hoverBtnTextColor={
                item.hoverBtn.txtColor.rgb || {
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                }
              }
              hoverBtnBgColor={
                item.hoverBtn.btnBg.rgb || { r: 0, g: 98, b: 204, a: 1 }
              }
              hoverBorder={
                item.hoverBtn.btnBorder.rgb || {
                  r: 12,
                  g: 50,
                  b: 84,
                  a: 1,
                }
              }
              floatVal={item.style.float}
              cloneElement={ props.cloneElement}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "TEXT") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            {/* <ErrorBoundary> */}
            <Text
              selectedFont={props.selectedFont}
              elementsFont={props.elementsFont}
              preset={props.preset}
              mobileView={props.mobileView}
              mobileAlign={item.mobileAlign ? item.mobileAlign : ""}
              desktopAlign={item.desktopAlign ? item.desktopAlign : ""}
              pagesList={props.pagesList}
              keyID={item.id}
              key={`${item.data}-${index}`}
              itemIndex={index}
              ID={item.id}
              element={item}
              editVal={item.edit}
              deleteElement={ props.deleteElement}
              editOption={item.edit}
              lineHeightVal={item.style.lineHeight}
              maxWidth={item.maxWidth}
              marginLeft={item.marginLeft}
              textContent={item.text}
              label={item.label}
              cloneElement={ props.cloneElement}
              fontSize={item.style.fontSize}
              fontName={item.style.fontFamily}
              marginTop={item.style.marginTop || 0}
              marginRight={item.style.marginRight || 0}
              marginBottom={item.style.marginBottom || 0}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "IMAGE") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <Image
              mobileView={props.mobileView}
              mobileAlign={item.mobileAlign ? item.mobileAlign : ""}
              pagesList={props.pagesList}
              Link={item.link}
              element={item}
              LinkName={item.linkname}
              LinkType={item.linktype}
              LinkOpen={item.linkopen}
              UseSocial={item.use_social}
              initP={props.initP}
              userID={props.userID}
              key={`${item.data}-${index}`}
              sessionID={props.sessionID}
              keyID={index}
              ID={item.id}
              label={item.label}
              srcID={item.srcID}
              src={item.src}
              // style={item.style}
              edit={item.edit}
              showImageSetting={props.showImageSetting}
              //imageClicked={props.imageClicked}
              addImage={() => props.addImage(item.id)}
              clickedImage={props.clickedImage}
              clickedImageID={props.clickedImageID}
              toggleUploadPopup={props.toggleUploadPopup}
              deleteElement={ props.deleteElement}
              width={item.style.maxWidth}
              height={item.style.height}
              radius={item.style.borderRadius}
              imageMarginUnit={item.style.imageMarginUnit}
              imageWidthUnit={item.style.imageWidthUnit}
              marginTop={item.style.marginTop || 0}
              marginRight={item.style.marginRight || 0}
              marginBottom={item.style.marginBottom || 0}
              marginLeft={item.style.marginLeft || 0}
              float={item.style.float}
              opacity={item.style.opacity}
              URL={item.href}
              changeImage={() => props.changeImage(item.id)}
              cloneElement={ props.cloneElement}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "Line") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={"item "}
          >
            <Line
              display={item.style.display}
              margin={item.style.margin}
              key={`${item.data}-${index}`}
              label={item.label}
              element={item}
              lineMarginUnit={item.style.lineMarginUnit}
              marginTop={item.style.marginTop}
              marginRight={item.style.marginRight}
              marginBottom={item.style.marginBottom}
              marginLeft={item.style.marginLeft}
              borderColor={item.style.borderColor}
              borderWidth={item.style.borderWidth}
              backgroundColor={item.style.backgroundColor}
              style={item.style}
              preset={props.preset}
              width={item.style.width}
              ID={item.id}
              deleteElement={ props.deleteElement}
              cloneElement={ props.cloneElement}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "TABLE") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <TABLEEditor
              selectedFont={props.selectedFont}
              element={item}
              mobileView={props.mobileView}
              pagesList={props.pagesList}
              ID={item.id}
              edit={item.edit}
              mobileContent={item.mobileStyle.content} 
              desktopContent={item.desktopStyle.content}
              isMirrored={item.isMirrored}
              key={`${item.data}-${index}`}
              label={item.label}
              deleteElement={ props.deleteElement}
              cloneElement={ props.cloneElement}
              tableMobileUnit={item.tableMobileUnit}
              tableDesktopUnit={item.tableDesktopUnit}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "HTML") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <HTMLEditor
              element={item}
              mobileView={props.mobileView}
              pagesList={props.pagesList}
              ID={item.id}
              edit={item.edit}
              content={item.content}
              selectedFont={props.selectedFont}
              key={`${item.data}-${index}`}
              deleteElement={ props.deleteElement}
              cloneElement={ props.cloneElement}
              preset={props.preset}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "TIMER") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <TimerElement
              ID={item.id}
              date={item.date}
              key={`${item.data}-${index}`}
              size={item.size}
              label={item.label}
              element={item}
              patternStyle={item.patternStyle}
              float={item.style.float}
              timerMarginUnit={item.style.timerMarginUnit}
              fontFamily={item.style.fontFamily || "Open Sans"}
              marginTop={item.style.marginTop}
              marginRight={item.style.marginRight}
              marginBottom={item.style.marginBottom}
              marginLeft={item.style.marginLeft}
              deleteElement={ props.deleteElement}
              cloneElement={ props.cloneElement}
              mobileView={props.mobileView}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "FILE") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <File
              marginTop={item.style.marginTop || 0}
              marginBottom={item.style.marginBottom || 0}
              fileMarginUnit={item.style.fileMarginUnit}
              fileWidthUnit={item.style.fileWidthUnit}
              initP={props.initP}
              userID={props.userID}
              key={`${item.data}-${index}`}
              sessionID={props.sessionID}
              element={item}
              keyID={index}
              ID={item.id}
              thumbID={item.thumbID}
              label={item.label}
              thumb={item.thumb}
              files={item.files}
              deleteElement={ props.deleteElement}
              cloneElement={ props.cloneElement}
              style={item.style}
              opacity={item.style.opacity}
              radius={item.style.borderRadius}
              width={item.style.maxWidth}
              float={item.style.float}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "VIDEO") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <VideoElement
              showChaptersToggle={item.showChaptersToggle}
              if_src={item.src}
              element={item}
              key={`${item.data}-${index}`}
              ID={item.id}
              videoOption={() => {
                props.videoOption(item.id);
              }}
              vimeoID={item.vimeoID || null}
              youtubeID={item.youtubeID || null}
              vimeoTHUMB={item.vimeoTHUMB || null}
              youtubeTHUMB={item.youtubeTHUMB || null}
              video_url={item.video_url || null}
              addVideo={() => {
                props.addVideo(item.id, item.videoID);
              }}
              label={item.label}
              videoTitle={item.videoTitle}
              deleteElement={ props.deleteElement}
              VideoWidth={item.style.maxWidth}
              srcID={item.srcID}
              editEnable={item.edit}
              marginTop={item.style.marginTop || 0}
              marginBottom={item.style.marginBottom || 0}
              videoMarginUnit={item.style.videoMarginUnit}
              videoWidthUnit={item.style.videoWidthUnit}
              modalUpload={props.modalUpload}
              selectedFile={props.selectedFile}
              toggleUploadPopup={props.toggleUploadPopup}
              dragLeave={props.dragLeave}
              onChangeHandler={props.onChangeHandler}
              videoClicked={props.videoClicked}
              videoDataID={props.videoDataID}
              autoplay={item.autoplay}
              modal={item.modal}
              chapters={item.chapters}
              control={item.control}
              layout={props.layoutState}
              userID={props.userID}
              cloneElement={ props.cloneElement}
              initP={props.initP}
              sessionID={props.sessionID}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "FORM") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={
              "item " + (props.enableWidthForRow ? "enable-width-for-row" : "")
            }
          >
            <Form
              Layout={props.layoutState}
              FormObj={item}
              formArray={item.fields}
              key={`${item.data}-${index}`}
              ID={item.id}
              element={item}
              width={item.style.width}
              borderWidth={item.style.borderWidth}
              borderStyle={item.style.borderStyle}
              borderRadius={item.style.borderRadius}
              borderColor={item.style.borderColor}
              formMarginUnit={item.style.formMarginUnit}
              fontFamily={item.style.fontFamily || "Open Sans"}
              label={item.label}
              marginTop={item.style.marginTop || 0}
              marginRight={item.style.marginRight || 0}
              marginBottom={item.style.marginBottom || 0}
              marginLeft={item.style.marginLeft || 0}
              backgroundColor={item.style.backgroundColor}
              color={item.style.color}
              email={item.email}
              deleteElement={ props.deleteElement}
              cloneElement={ props.cloneElement}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
    if (item && item.data == "Row") {
      return (
        <ErrorBoundary key={`${item.data}-${index}-wrapper`}>
          <Draggable
            element={item}
            style={
              dragOverElement &&
              (dragOverElement.id === item.id) & (barLocation === "Bottom")
                ? { borderBottom: "12px solid #C2F5B8" }
                : dragOverElement &&
                  (dragOverElement.id === item.id) & (barLocation === "Top")
                ? { borderTop: "12px solid #C2F5B8" }
                : {}
            }
            onDrag={(e) => {
              onDrag(e, item, props.parent, index);
            }}
            onDragOver={(e) => {
              onDragOver(e);
            }}
            onDragEnter={(e) => {
              onDragEnter(e, item, index, props.parent);
            }}
            onDrop={(e) => {
              onDrop(e);
            }}
            onDragEnd={onDragEnd}
            enableWidthForRow={props.enableWidthForRow}
            width={props.containerWidth}
            tool={UTILS.tool}
            key={`${item.data}-${index}-wrapper`}
            onAddElementorColumn={props.onAddElementorColumn}
            ID={item.id}
            mobileView={props.mobileView}

            classlist={"item rowMain "}
          >
            <RowColumns
              key={`${item.data}-${index}`}
              onDrag={(e) => {
                onDrag(e, item, props.parent, index);
              }}
              onDragOver={(e) => {
                onDragOver(e);
              }}
              onDragEnter={(e) => {
                onDragEnter(e, item, index, props.parent);
              }}
              onDrop={(e) => {
                onDrop(e);
              }}
              onDragEnd={onDragEnd}
              preset={props.preset}
              selectedFont={props.selectedFont}
              showAddElement={props.showAddElement}
              tool={props.tool}
              preventDrop={props.preventDrop}
              pagesList={props.pagesList}
              ID={item.id}
              onAddElementorColumn={props.onAddElementorColumn}
              onAddElementorColumnInColumn={props.onAddElementorColumnInColumn}
              deleteElement={
                props.deleteElement
              }
              cloneElement={
                props.cloneElement
              }
    
              payload={props.payload}
              payloadActive={props.payloadActive}
              changeColmLayout={props.changeColmLayout}
              mobileView={props.mobileView}
              resizeID={props.resizeID}
              resizeColumn={() => {
                props.resizeColumn(item.id);
              }}
              label={item.label}
              deskWidth={item.deskWidth}
              index={index}
              addedIndex={props.addedIndex}
              initP={props.initP}
              userID={props.userID}
              sessionID={props.sessionID}
              rowStyle={item.rowStyle ? item.rowStyle : null}
              rowBg={
                item.rowStyle && item.rowStyle.rowBg
                  ? item.rowStyle.rowBg
                  : undefined
              }
              rowOpacity={
                item.rowStyle && item.rowStyle.opacity
                  ? item.rowStyle.opacity
                  : "1.0"
              }
              rowBgColor={
                item.rowStyle && item.rowStyle.rowBgColor
                  ? item.rowStyle.rowBgColor
                  : "transparent"
              }
              rowBorderColor={
                item.rowStyle && item.rowStyle.rowBorderColor
                  ? item.rowStyle.rowBorderColor
                  : "#000000"
              }
              gutterSpaceBtwnCol={
                item.rowStyle && item.rowStyle.gutterSpaceBtwnCol
                  ? item.rowStyle.gutterSpaceBtwnCol
                  : "0"
              }
              gutterSpaceBtwnColMobile={
                item.rowStyle && item.rowStyle.gutterSpaceBtwnColMobile
                  ? item.rowStyle.gutterSpaceBtwnColMobile
                  : "0"
              }
              bgRepeat={
                item.rowStyle && item.rowStyle.bgRepeat
                  ? item.rowStyle.bgRepeat
                  : "no-repeat"
              }
              bgSize={
                item.rowStyle && item.rowStyle.bgSize
                  ? item.rowStyle.bgSize
                  : "cover"
              }
              borderWidth={
                item.rowStyle && item.rowStyle.borderWidth
                  ? item.rowStyle.borderWidth
                  : "0"
              }
              rowCroppedBg={
                item.rowStyle && item.rowStyle.croppedBg !== null
                  ? item.rowStyle.croppedBg
                  : undefined
              }
              rowBgWidth={
                item.rowStyle && item.rowStyle.bgWidth
                  ? item.rowStyle.bgWidth
                  : undefined
              }
              element={item}
              columns={item.columns}
              addRemoveColumn={props.addRemoveColumn}
              removeColumn={props.removeColumn}
              itemID={props.itemID}
              imageClicked={props.imageClicked}
              addImage={props.addImage}
              changeImage={props.changeImage}
              clickedImage={props.clickedImage}
              clickedImageID={props.clickedImageID}
              layout={props.layoutState}
              toggleUploadPopup={props.toggleUploadPopup}
              dragLeave={props.dragLeave}
              onChangeHandler={props.onChangeHandler}
              modalUpload={props.modalUpload}
              selectedFile={props.selectedFile}
              videoClicked={props.videoClicked}
              videoDataID={props.videoDataID}
              addVideo={props.addVideo}
              videoOption={props.videoOption}
            />
          </Draggable>
        </ErrorBoundary>
      );
    }
  });

  return (
    <>
      {layoutElements}
      {props.layout.length === 0 && (
        <AddToolButton
          showAddElement={props.showAddElement}
          tool={UTILS.tool}
          layout={props.layout}
          block={true}
          mobileView={props.mobileView}
          onAddElementorColumnInColumn={props.onAddElementorColumnInColumn}
          onAddElementorColumn={props.onAddElementorColumn}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutList: state.present.layoutList,
    preset: state.present.preset,
    layoutTitle: state.present.layoutTitle,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ElementsRender);
